import { z } from 'zod';
import { displayNameSchema } from './auth.js';
import { permissionKeySchema } from './permissions.js';
import { assignableRoleSchema, memberRoleSchema, memberStatusSchema } from './roles.js';
export const memberSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    role: memberRoleSchema,
    status: memberStatusSchema,
    /** True when this person can sign in (has a login linked). */
    hasLogin: z.boolean(),
    /** The owner has allowed this member to mark their own accounts as private. */
    privateAccountsAllowed: z.boolean(),
    createdAt: z.string(),
});
export const permissionOverrideSchema = z.object({
    key: permissionKeySchema,
    allowed: z.boolean(),
});
export const memberDetailSchema = memberSchema.extend({
    overrides: z.array(permissionOverrideSchema),
    permissions: z.array(permissionKeySchema),
});
export const memberListResponseSchema = z.object({
    items: z.array(memberSchema),
    /** Cursor for the next page, or null when there are no more. */
    nextCursor: z.string().nullable(),
});
export const createMemberRequestSchema = z.object({
    displayName: displayNameSchema,
    role: assignableRoleSchema,
});
export const updateMemberRequestSchema = z
    .object({
    displayName: displayNameSchema,
    role: assignableRoleSchema,
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, 'Nothing to update');
export const setPermissionsRequestSchema = z.object({
    overrides: z
        .array(permissionOverrideSchema)
        .max(50)
        .refine((list) => new Set(list.map((o) => o.key)).size === list.length, 'Duplicate permission'),
});
//# sourceMappingURL=members.js.map